module.exports = __webpack_public_path__ + "static/img/7bg_4.04ca155.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/7bg_4.png
// module id = 750
// module chunks = 1